import { readable, writable } from 'svelte/store';
import { auth as firebaseAuth, db } from '../config/firebase';
import { signInWithGitHub, signOut } from "../helpers/auth";
import { doc, getDoc } from "firebase/firestore";
export const githubAppUrl = readable("https://github.com/apps/unity-pr-bot");
export const appName = readable("Unity PR Bot");
export const mailAddress = readable("hi@unityprbot.com");
function createAuth() {
    const { subscribe, set } = writable();
    firebaseAuth.onAuthStateChanged((newState) => {
        set(newState);
    });
    return {
        subscribe,
        signIn: signInWithGitHub,
        signOut: signOut,
    };
}
function createAnalytics() {
    const { subscribe, set } = writable({ builds: 0, clients: 0 });
    const useAnalytics = false;
    // to postpone until we have enough users
    if (useAnalytics) {
        getDoc(doc(db, "analytics/reports")).then(snapshot => {
            if (snapshot.exists()) {
                set(snapshot.data());
            }
        });
    }
    else {
        new Promise((resolve, _) => {
            setTimeout(() => {
                resolve({ builds: 254, clients: 15 });
            }, 500);
        }).then(result => { set(result); });
    }
    return { subscribe };
}
function createOrganizationStores() {
    const { subscribe, set, update } = writable();
    function updateOrganization(orgs, newOrg) {
        for (let i = 0; i < orgs.length; i++) {
            if (orgs[i].name == newOrg.name) {
                orgs[i] = newOrg;
                return orgs;
            }
        }
        return orgs;
    }
    return {
        subscribe,
        update: (updatedOrg) => update(orgs => orgs = updateOrganization(orgs, updatedOrg)),
        set: (organizations) => set(organizations)
    };
}
export const auth = createAuth();
export const orgStore = createOrganizationStores();
export const analytics = createAnalytics();
